export const editEditorCommand = (editor) => {
    // editor.Components.addType('default', {
    //     view: {
    //         init() {
    //             const toolbar = this.model.get('toolbar');
    //             if (!toolbar.find((item) => item.command === 'edit-command')) {
    //                 toolbar.push({
    //                     id: 'edit-btn',
    //                     command: 'edit-command',
    //                     className: 'fa fa-pencil',
    //                     attributes: { title: 'Edit Component' },
    //                     label:
    //                         '<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" focusable="false"><path d="M20.1 5.1L16.9 2 6.2 12.7l-1.3 4.4 4.5-1.3L20.1 5.1zM4 20.8h8v-1.5H4v1.5z"></path></svg>',
    //                 });
    //             }
    //         },
    //     },
    // });

    // editor.Commands.add('edit-command', {
    //     run: (editor, sender) => {
    //         console.log('test');
    //     },
    // });
};
